import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// AdminRoute — email-allowlist gate for admin-only pages.
// Composes on top of ProtectedRoute (not a replacement).
// Use as:
//   <ProtectedRoute>
//     <AdminRoute>
//       <Layout><AdminDashboard /></Layout>
//     </AdminRoute>
//   </ProtectedRoute>
//
// Reads REACT_APP_ADMIN_EMAILS (comma-separated, trimmed,
// case-insensitive). Fail-closed: if the env var is unset
// or empty, no one is admin and all users are redirected.
// The _underscore prefix on the env var constant is a
// reminder that this is a build-time value in production
// but a runtime process.env read in tests (CRA test mode
// does not use DefinePlugin inlining).
export default function AdminRoute({ children }) {
  const { user } = useAuth();
  const allowlist = (process.env.REACT_APP_ADMIN_EMAILS || "")
    .split(",")
    .map(s => s.trim().toLowerCase())
    .filter(Boolean);
  const userEmail = user?.email ? user.email.trim().toLowerCase() : null;
  const isAdmin = userEmail && allowlist.includes(userEmail);
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}
